import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'ageFromDate'
})
export class AgeFromDatePipe implements PipeTransform {
  transform(birthday: string, endDate?: string): string {
    const birthdayMoment = moment(birthday, 'DD/MM/YYYY');
    const endDateMoment = endDate ? moment(endDate, 'DD/MM/YYYY') : moment();

    // Use moment's diff function to calculate age more accurately and easily
    const years = endDateMoment.diff(birthdayMoment, 'years');
    const months = endDateMoment.diff(birthdayMoment, 'months') % 12; // Remainder of months after accounting for full years
    const days = endDateMoment.diff(birthdayMoment.add(years, 'years').add(months, 'months'), 'days'); // Days after accounting for full years and months

    // Format the age string based on what's most significant (years, months, or days)
    if (years > 0) {
      return `${years} ${years === 1 ? 'year' : 'years'} old`;
    } else if (months > 0) {
      return `${months} ${months === 1 ? 'month' : 'months'} old`;
    } else if (days >= 0) { // Include 0 to handle the case of the birthday being today
      return `${days} ${days === 1 ? 'day' : 'days'} old`;
    }
    return "Age cannot be calculated"; // Fallback message
  }
}
